module.exports = __webpack_public_path__ + "img/Dantam Makeover 27.bd045279.jpg";